import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

interface Props {
  werkOrderId: string;
  /** Alleen voor de tooltip — welke order het label betreft. */
  orderReferentie?: string;
  compact?: boolean;
  /** Vervangt de standaardopmaak, zodat de knop in een bestaande actiebalk past. */
  className?: string;
}

/**
 * Opent het A4-retourlabel van een B2B-inkooporder in een nieuw tabblad, klaar
 * om te printen en op de zak te plakken. Token in de URL omdat een tabblad geen
 * Authorization-header kan meesturen — zelfde patroon als InvoicePdfButton.
 *
 * Het label hoort bij de order die RETOUR gaat, dus deze knop staat op de
 * openstaande vorige order(s), niet op de order die net is aangemaakt.
 */
export function B2BRetourlabelButton({ werkOrderId, orderReferentie, compact, className }: Props) {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setToken(data.session?.access_token ?? null);
    });
  }, []);

  if (!token) return null;

  const url = `/api/orders/b2b-retourlabel?werkOrderId=${werkOrderId}&token=${token}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={
        orderReferentie
          ? `Print het retourlabel met het inkoopnummer van ${orderReferentie}`
          : 'Print het retourlabel met het inkoopnummer'
      }
      className={
        className ??
        (compact
          ? 'inline-flex items-center gap-1 text-xs text-slate-600 hover:text-slate-900'
          : 'inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded border border-slate-300 text-slate-700 hover:bg-slate-50')
      }
    >
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"
        />
      </svg>
      Retourlabel
    </a>
  );
}
